/** Junta partes não-vazias com ", ", aparando espaços e descartando vazios/nulos. */
function joinParts(parts) {
    return parts
        .map((s) => (s ?? '').trim())
        .filter((s) => s.length > 0)
        .join(', ');
}
/** Formata CEP para `00000-000` quando vier com 8 dígitos; senão devolve aparado. */
export function formatCep(cep) {
    const raw = (cep ?? '').trim();
    if (raw === '')
        return '';
    const digits = raw.replace(/\D/g, '');
    if (digits.length === 8)
        return `${digits.slice(0, 5)}-${digits.slice(5)}`;
    return raw;
}
/**
 * Compõe o endereço completo a partir das partes, sem os artefatos da Formula legada.
 *
 * Ex.: `{ logradouro:'Avenida Paulista', numero:'1578', complemento:'Sala 1502',
 *        bairro:'Bela Vista', cidade:'São Paulo', uf:'SP', cep:'01310100' }`
 * → `"Avenida Paulista, 1578, Sala 1502, Bela Vista, São Paulo - SP, 01310-100"`.
 *
 * - `complemento` vazio não gera vírgula dupla.
 * - bairro entra sem prefixo "Bairro ".
 * - cidade + uf juntam com " - " (sem duplicar UF); se só um existir, usa o que houver.
 */
export function formatEnderecoCompleto(p) {
    const rua = joinParts([p.logradouro, p.numero, p.complemento]);
    const cidadeUf = [p.cidade, p.uf]
        .map((s) => (s ?? '').trim())
        .filter((s) => s.length > 0)
        .join(' - ');
    return joinParts([rua, p.bairro, cidadeUf, formatCep(p.cep)]);
}
//# sourceMappingURL=endereco.js.map